import { AxiosRequestConfig, AxiosResponse } from 'axios';
import client from 'api/client';
import { Client } from '../models/response';

export function get(
    clientType?: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<Client[]>> {
    const url = clientType ? `/my_clients/${clientType}` : `/my_clients`;
    return client.get<Client[]>(url, customConfig);
}
